import * as styles from "./Footer.module.css";
export default function Footer() {
  return (
    <footer className={styles.footer}>
      Copyright © {new Date().getFullYear()} Oluwatobi Sofela • All rights
      reserved.
    </footer>
  );
}
